import { atom } from "recoil";
import { generate } from "shortid";
import { CrossdockStateKey } from "./CrossdockStateKey";

export const clientIdState = atom<string>({
  key: CrossdockStateKey.CLIENT_ID,
  default: generate(),
});
